export default __webpack_public_path__ + "static/tabs-content-do-b7db443708aa68ec710dd81a2f00bf3b760dfe5c44dd90988acb58e49d796e2d.png";